module.exports = __webpack_public_path__ + "img/payments.by.currency.b229e72e.png";